import store from '../index'
import { resetMayaState } from '../maya/actions'
import {
  RESET_GENERAL_STATE,
  SET_GENERAL_CONFIG,
  SET_IS_POPOVER_CHAT_OPEN,
  DEFAULT_OPEN_POPOVER_CHAT,
  OPEN_POPOVER_ON_CLICKTRHOUGH,
  ADD_PAYWALL,
  SET_IS_PAID_USER,
  SET_SHOW_SEND_CHAT_MODAL,
} from './constants'

export const resetAppState = () => {
  store.dispatch(resetGeneralState())
  store.dispatch(resetMayaState())
}

export const resetGeneralState = payload => dispatch =>
  dispatch({ type: RESET_GENERAL_STATE, payload: payload })

export const setGeneralConfig = config => dispatch =>
  dispatch({ type: SET_GENERAL_CONFIG, payload: config })

export const setIsPopoverChatOpen = isOpen => dispatch =>
  dispatch({ type: SET_IS_POPOVER_CHAT_OPEN, payload: isOpen })

export const setOpenPopoverOnClickthrough = canOpen => dispatch =>
  dispatch({ type: OPEN_POPOVER_ON_CLICKTRHOUGH, payload: canOpen })

export const autoOpenPopoverChat = isOpen => dispatch =>
  dispatch({ type: DEFAULT_OPEN_POPOVER_CHAT, payload: isOpen })

export const setLimitMessagesCase = payload => dispatch =>
  dispatch({ type: ADD_PAYWALL, payload: payload })

export const setUserByPassMessagesLimit = payload => dispatch =>
  dispatch({ type: SET_IS_PAID_USER, payload: payload })

export const setShowSendChatModal = isOpen => dispatch =>
  dispatch({ type: SET_SHOW_SEND_CHAT_MODAL, payload: isOpen })
